const ADVERTS_IMAGES =
  process.env.REACT_APP_ADVERTS_IMAGES ||
  JSON.stringify({
    images: [
      {
        src: "/carousel/QUICKbUCKS_WEB_BANNER_1.jpg",
        link: "https://google.com",
      },
      {
        src: "/carousel/QUICKbUCKS_WEB_BANNER_2.jpg",
        link: "https://www.accessbankplc.com",
      },
      // {
      //   src: "https://i.ibb.co/mB7281w/personal-banking.png",
      //   link: "https://www.accessbankplc.com",
      // },
    ],
  });

export const advertsImages: Array<{ src: string; link: string }> = JSON.parse(
  ADVERTS_IMAGES?.trim() || "[]"
)?.images;

// export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://digitallending.accessbankplc.com:9091';
export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  "https://quickbucks-backend.accessbankplc.com";
export const API_BASE_URL_ACCOUNT =
  process.env.REACT_APP_ACCOUNT_API_BASE_URL ||
  "https://quickbucks-account.accessbankplc.com/";
